import styled from 'styled-components';

export const ChartDummyContainer = styled.div`
   z-index: 1;
   max-width: 500px;
   min-height: 450px;
   border-top: 2px solid #aaa;
   border-bottom: 1px solid #aaa;
   margin-top: 2px;
   margin: 0 auto;
   margin-bottom: 50px;
   color: #eee;
   display: block;
   width: 100%;
   height: auto;

   #dummy-note-click-to-chart {
      margin-top: 20px;
   }

   @media only screen and (min-width: 1200px) {
      width: 500px;
      display: block;
      min-height: 435px;
      margin: 2px 0 25px 0;

      img#chartdummy {
         width: 500px;
      }
   }
`;

export const ChartDummyImage = styled.img`
   width: 100%;
`;
